import JSRouter from "adminPage/JSRouter";
import FormValidator from "base/FormValidator";
import FieldEditor from "editor/FieldEditor";
import AddContentInputModal from "content/AddContentInputModal";
import AddContentModalInputModal from "content/AddContentModalInputModal";
import Ajax from "base/Ajax";
import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";
import ItemOrderer from "base/ItemOrderer";
import Slug from "slug";

JSRouter.register('content', /^\/([0-9a-f]+|add)\/?$/, (url_args, page_data) => {
    let input_types = {};
    page_data[0].forEach((type) => input_types[type.id] = type);
    let content_type_data = page_data.length > 1 && page_data[1] !== null ? page_data[1] : {};

    FormValidator.attach($(".js-content-type-form")).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        let data = {
            name: $form.find(".js-name").val(),
            baseUrl: $form.find(".js-base-url").val(),
            inputs: inputs.map((input) => input.getValue()),
            notifySubscribers: $form.find(".js-notify-subscribers").is(":checked"),
            showAddModal: $form.find(".js-show-add-modal").is(":checked"),
            addModalInputs: modalOrderer.items.map((item) => ({
                id: item.item ? item.item.id : undefined,
                input: item.input.uuid,
            })),
            modalTitle: $form.find(".js-modal-title").val(),
        };

        let prom;

        if ("undefined" === typeof content_type_data.id) {
            //Creating a new content type
            prom = Ajax.post('content', '', data).then((data) => {
                Message.schedule(new Message('Content Type Added Successfully', '', Message.SUCCESS));
                window.location.href = data.links.edit;
            });
        } else {
            //Updating a content type that already exists
            prom = Ajax.put(null, content_type_data.href, data).then((data) => {
                $btn.removeClass("admin-btn--loading");
                new Message('Content Type Saved Successfully', '', Message.SUCCESS);
                loadEditors(Object.values(data.inputs));
                loadModalInputs(data.addModalInputs);
            });
        }
        prom.catch((e) => {
            console.log(e);
            new Message(e.message, "Couldn't save the content type");
            $btn.removeClass("admin-btn--loading");
        })
    });

    let inputs = [];
    let modalOrderer = new ItemOrderer($('.js-modal-items-orderer'));

    $("body").on("click", ".js-add-field", () => {
        let modal = new AddContentInputModal();


        modal.on("submit", (data) => {
            let slug = Slug(data.name, {mode: 'rfc3986'});
            let slugAlreadyUsed = 0;
            inputs.forEach((input) => {
                if (input.getSettingValue('slug') === slug) {
                    slugAlreadyUsed++;
                }
            });
            if (slugAlreadyUsed > 0) {
                slug += '-' + slugAlreadyUsed;
            }

            let editor = handleFieldEditor(data.type, {name: data.name, slug: slug});
            editor.open = true;
            editor.update();
            modal.destroy()
        }).on("cancel", () => modal.destroy());

        modal.show();
        return false;
    }).on("click", ".js-delete-content-type", () => {
        ConfirmModal.confirm('Are you sure you want to delete this content type? All posts will also be deleted!', undefined, {showLoading: true}).then((done) => {
            Ajax.delete(null, content_type_data.href).then(() => {
                Message.schedule(new Message('Content type deleted successfully', '', Message.SUCCESS));
                window.location.href = window.CONFIG.urls.admin + 'content';
            }).catch((e) => {
                console.log(e);
                new Message(e.message, "Couldn't delete the content type");
                done();
            })
        });
        return false;
    }).on("change", ".js-show-add-modal", function () {
        if ($(this).is(":checked")) {
            $(".js-modal-items-wrap").show();
        } else {
            $(".js-modal-items-wrap").hide();
        }
    }).on("click", ".js-add-modal-input", () => {
        let currentModalInputs = modalOrderer.items.map((item) => item.input);
        let modal = new AddContentModalInputModal(inputs.filter((item) => currentModalInputs.indexOf(item) === -1 && input_types[item.getInputType()].modalEditor !== null));

        modal.on("submit", (input) => {
            modalOrderer.addItem({
                input: input,
                name: input.getSettingValue('name'),
                subText: input.constructor.get_name(),
                removable: true
            });
            modal.destroy();
        }).on("cancel", () => modal.destroy());

        modal.show();
        return false;
    });

    if ("undefined" !== typeof content_type_data.inputs) {
        loadEditors(Object.values(content_type_data.inputs));
    }
    if ("undefined" !== typeof content_type_data.addModalInputs) {
        loadModalInputs(content_type_data.addModalInputs);
    }

    function loadEditors(input_datas) {
        inputs.forEach((editor) => {
            editor.destroy();
        });
        inputs = [];
        $(".js-fields-container").html("");
        input_datas.forEach((input) => {
            handleFieldEditor(input.type.adminEditor, input);
        })
    }

    function loadModalInputs(modalInputs) {
        modalInputs = modalInputs.map((item) => {
            let input = inputs.reduce((prev, current) => {
                return current.getValue().id === item.input.id ? current : prev
            }, null);
            if (input === null) {
                console.warn("Missing input: " + item);
                return undefined;
            }
            return {
                item: item,
                input: input,
                name: input.getSettingValue('name'),
                subText: input.constructor.get_name(),
                removable: true
            }
        }).filter((item) => "undefined" !== typeof item);
        modalOrderer.setItems(modalInputs);
    }

    function handleFieldEditor(type, value) {
        let $elem = eotwJSXFactory('div', {class: "admin-form__row"});
        let editor = FieldEditor.get_editor(type, $elem);
        editor.setValue(value);

        editor.on("remove", () => {
            editor.destroy();
            inputs = inputs.filter((other) => other !== editor);
            editor.$element.remove();
        });

        inputs.push(editor);
        $(".js-fields-container").append($elem);
        return editor;
    }
});
